"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdCampaignIntervalExactGenerator = void 0;
var enums_1 = require("../../../../enums");
var utils_1 = require("../utils");
var types_1 = require("../../types");
var DateTimeCheckService_1 = __importDefault(require("../../../DateTimeCheckService"));
var base_1 = require("../base");
var AdCampaignIntervalExactGenerator = (function (_super) {
    __extends(AdCampaignIntervalExactGenerator, _super);
    function AdCampaignIntervalExactGenerator(adCampaign, timezone, logger, tracing, cutDuration, addToSkipped) {
        var _this = _super.call(this, adCampaign, timezone) || this;
        _this.cutDuration = 0;
        _this.promos = adCampaign.promos;
        _this.promoIterator = new utils_1.PromoIterator(_this.promos);
        _this.logger = logger;
        _this.tracing = tracing;
        _this.cutDuration = cutDuration || 0;
        _this.addToSkipped = addToSkipped;
        return _this;
    }
    AdCampaignIntervalExactGenerator.prototype.inInvalidState = function () {
        return this.adcampaign.interval < 1 || this.adcampaign.promos.length < 1;
    };
    AdCampaignIntervalExactGenerator.prototype.isPreviousMediafileRequired = function () {
        return this.adcampaign.prevMediafileRequired;
    };
    AdCampaignIntervalExactGenerator.prototype.hasPreviousMediafile = function (rotations) {
        var _a, _b;
        return rotations.length > 0 && ((_b = (_a = rotations[rotations.length - 1]) === null || _a === void 0 ? void 0 : _a.mediafile) === null || _b === void 0 ? void 0 : _b.type) === 0;
    };
    AdCampaignIntervalExactGenerator.prototype.isPromoConflict = function (rotations) {
        var _a, _b, _c;
        return Boolean(((_a = rotations[rotations.length - 1]) === null || _a === void 0 ? void 0 : _a.campaignType) &&
            !((_b = rotations[rotations.length - 1].endTime) === null || _b === void 0 ? void 0 : _b.isBefore((_c = this.targetTime) === null || _c === void 0 ? void 0 : _c.clone().add(this.cutDuration, "seconds"))));
    };
    AdCampaignIntervalExactGenerator.prototype.getInsertTime = function (rotations) {
        var _a;
        if (!this.cutDuration) {
            return this.targetTime;
        }
        var prevTime = rotations[rotations.length - 1].endTime;
        var nextTimeWithCutDuration = (_a = this.targetTime) === null || _a === void 0 ? void 0 : _a.clone().add(this.cutDuration, "seconds");
        var result = (nextTimeWithCutDuration === null || nextTimeWithCutDuration === void 0 ? void 0 : nextTimeWithCutDuration.isBefore(prevTime)) ? nextTimeWithCutDuration : prevTime;
        return result;
    };
    AdCampaignIntervalExactGenerator.prototype.initializePromoIterator = function (lastRotations) {
        if (!lastRotations) {
            return;
        }
        var lastPromo = (0, utils_1.getLastPromo)(lastRotations, this.adcampaign.id);
        if (lastPromo === null || lastPromo === void 0 ? void 0 : lastPromo.startNextMark) {
            this.promoIterator.skipToPromo(lastPromo.mediafileId);
        }
    };
    AdCampaignIntervalExactGenerator.prototype.initializeTargetTime = function (nextTime) {
        var _a, _b, _c, _d;
        this.targetTime = nextTime.clone();
        var hours = ((_b = (_a = this.adcampaign) === null || _a === void 0 ? void 0 : _a.startDayTime) === null || _b === void 0 ? void 0 : _b.h) || 0;
        var minutes = ((_d = (_c = this.adcampaign) === null || _c === void 0 ? void 0 : _c.startDayTime) === null || _d === void 0 ? void 0 : _d.m) || 0;
        this.targetTime.hours(hours).minutes(minutes).second(0);
        this.updateTargetTime(nextTime, false);
    };
    AdCampaignIntervalExactGenerator.prototype.updateTargetTime = function (nextTime, wasSkipped) {
        var _a;
        if (!this.targetTime) {
            this.initializeTargetTime(nextTime);
            return;
        }
        while (this.targetTime.isSameOrBefore(nextTime)) {
            if (wasSkipped) {
                var result = this.convertPromoToRotation({
                    mediafileData: this.promoIterator.getPromo(),
                    insertTime: this.targetTime,
                    campaignType: enums_1.EAdCampaignType.INTERVAL,
                    adcompanyId: this.adcampaign.id,
                });
                (_a = this.addToSkipped) === null || _a === void 0 ? void 0 : _a.call(this, result.rotation);
            }
            this.targetTime = this.targetTime.clone().add(this.adcampaign.interval, "minutes");
        }
    };
    AdCampaignIntervalExactGenerator.prototype.getRotation = function (_a) {
        var _b;
        var rotations = _a.rotations, lastRotations = _a.lastRotations, nextTime = _a.nextTime;
        if (this.inInvalidState()) {
            return new types_1.GetRotationSkip();
        }
        if (!DateTimeCheckService_1.default.checkNextTimeForObject(this.adcampaign, nextTime)) {
            this.targetTime = null;
            return new types_1.GetRotationSkip();
        }
        if (!this.targetTime) {
            this.initializeTargetTime(nextTime);
            this.initializePromoIterator(lastRotations);
        }
        if (this.isPromoConflict(rotations)) {
            this.updateTargetTime(nextTime, true);
            return new types_1.GetRotationSkip();
        }
        if (this.isPreviousMediafileRequired() && !this.hasPreviousMediafile(rotations)) {
            this.updateTargetTime(nextTime, true);
            return new types_1.GetRotationSkip();
        }
        if ((_b = this.targetTime) === null || _b === void 0 ? void 0 : _b.isSameOrBefore(nextTime)) {
            var result = this.convertPromoToRotation({
                mediafileData: this.promoIterator.getPromo(),
                insertTime: this.getInsertTime(rotations) || this.targetTime,
                campaignType: enums_1.EAdCampaignType.INTERVAL,
                adcompanyId: this.adcampaign.id,
            });
            this.updateTargetTime(nextTime);
            return new types_1.GetRotationResult(result.nextTime, result.rotation);
        }
        this.updateTargetTime(nextTime);
        return new types_1.GetRotationSkip();
    };
    return AdCampaignIntervalExactGenerator;
}(base_1.AdGeneratorBaseAbstract));
exports.AdCampaignIntervalExactGenerator = AdCampaignIntervalExactGenerator;
//# sourceMappingURL=index.js.map